import { ReactElement } from "react";

export const isJSXElement = (value: any): value is ReactElement =>
    typeof value === "object" && value !== null && "$$typeof" in value;
